import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Avatar } from '../avatar';
import { ListRowFeaturedCell } from './featured_cell';
import { styled } from '../../styles';
const IconAvatarCellWrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    minWidth: '200px',
});
export const UserAvatarCell = ({ headline, subHeadline, onClick, avatarUrl = '', maskHeadline = false, maskSubHeadline = false, }) => (_jsxs(IconAvatarCellWrapper, { onClick: onClick, children: [_jsx(Avatar, { src: avatarUrl, displayName: headline, marginRight: '20px', size: 'small' }), _jsx(ListRowFeaturedCell, { testid: "user-cell", headline: headline, subHeadline: subHeadline, maskHeadline: maskHeadline, maskSubHeadline: maskSubHeadline })] }));
//# sourceMappingURL=user_avatar.js.map